import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('geometryShapeSitiosArqueologicos');

export const check = () => useBasicAuth.checkToken();

export const findAllGeometryShapeSitiosArqueologicos = () => 
  axios.get(urlAPI + "/all/" , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeSitiosArqueologicosInsideByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeSitiosArqueologicosIntersectsByCidade = (id) => 
  axios.get(urlAPI + "/byCidade/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeSitiosArqueologicosInsideByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/inside/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllGeometryShapeSitiosArqueologicosIntersectsByEstado = (id) => 
  axios.get(urlAPI + "/byEstado/intersects/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

